'use client';

import { useConsent } from '@/providers/consent-context';

export default function useAnalyticsTracking(integrationName) {
    const { canUseIntegration } = useConsent();

    const canTrack = canUseIntegration(integrationName);

    const trackEvent = (eventName, payload = {}, options = {}) => {
        const { pushToDataLayer = true, pushToGtag = false } = options;

        if (typeof window === 'undefined' || !canTrack) {
            return false;
        }

        let emitted = false;

        if (pushToGtag && typeof window.gtag === 'function') {
            window.gtag('event', eventName, payload);
            emitted = true;
        }

        if (pushToDataLayer && window.dataLayer) {
            window.dataLayer.push({
                event: eventName,
                ...payload
            });
            emitted = true;
        }

        if (pushToDataLayer && !window.dataLayer) {
            window.dataLayer = [];
            window.dataLayer.push({
                event: eventName,
                ...payload
            });
            emitted = true;
        }

        return emitted;
    };

    return {
        canTrack,
        trackEvent
    };
}